import React from 'react';
import WalletAuthorization from './components/WalletAuthorization';

function App() {
  return (
    <div>
      <WalletAuthorization />
    </div>
  );
}

export default App;
